import { FirebaseApp, initializeApp } from "firebase/app";
import { InjectionKey, Plugin } from "vue";

const appConfig = {
	apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "",
	projectId: import.meta.env.VITE_FIREBASE_PROJECT || "",
};

const FirebaseAppSymbol: InjectionKey<FirebaseApp> = Symbol();

export function useFirebaseApp() {
	const app = inject(FirebaseAppSymbol);
	if (app == null) {
		throw new Error("firebaseApp not available in current effect scope");
	}

	return app;
}

export const firebase: Plugin = {
	install(app) {
		const firebaseApp = initializeApp(appConfig);
		app.provide(FirebaseAppSymbol, firebaseApp);
	},
};
